import { ref } from "vue";

const STORAGE_KEY = "sidebar-collapsed";

const isCollapsed = ref(false);

const load = (): void => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored !== null) {
      isCollapsed.value = stored === "true";
    }
  } catch {
    // localStorage unavailable (e.g. CI/test environment)
  }
};

load();

export const useSidebarState = () => {
  const persist = (value: boolean): void => {
    try {
      localStorage.setItem(STORAGE_KEY, String(value));
    } catch {
      // localStorage unavailable (e.g. CI/test environment)
    }
  };

  const toggle = (): void => {
    isCollapsed.value = !isCollapsed.value;
    persist(isCollapsed.value);
  };

  const expand = (): void => {
    isCollapsed.value = false;
    persist(false);
  };

  const collapse = (): void => {
    isCollapsed.value = true;
    persist(true);
  };

  return { isCollapsed, toggle, expand, collapse };
};

// Only exported for unit tests — never call in production code
export const _resetForTest = (): void => {
  isCollapsed.value = false;
  load();
};
